import {Component} from '@angular/core';
import {PaymentMethodsBaseComponent} from "../payment-methods-base.component";
import {AgGridAngular} from "ag-grid-angular";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ContainerComponent, RowComponent, ColComponent} from "@coreui/angular";
import {MatOption, MatSelect} from "@angular/material/select";
import {ChooseYourGameComponent} from "../../../components/choose-your-game/choose-your-game.component";

@Component({
  selector: 'app-cross-game-payment-methods',
  standalone: true,
  imports: [
    AgGridAngular,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardContent,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    ReactiveFormsModule,
    FormsModule,
    ContainerComponent,
    RowComponent,
    ColComponent,
    MatSelect,
    MatOption,
    ChooseYourGameComponent
  ],
  templateUrl: '../payment-methods.component.html',
  styleUrl: './cross-game-payment-methods.component.scss'
})
export class CrossGamePaymentMethodsComponent extends PaymentMethodsBaseComponent {
  constructor() {
    super();
    this.isCrossGame = true;
  }
}
